var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDigitalProductionKanban(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-digitalProductionKanban"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-digitalProductionKanban",
    clipPath: "url(#clip-icon-digitalProductionKanban)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 135.263,
    cy: 135.263,
    r: 135.263,
    transform: "translate(171.889 366.34)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M550.8,846.28v9.62a32.683,32.683,0,0,1-32.69,32.69H90.695a27.2,27.2,0,0,1-27.2-27.2v-9.62c0-104.84,84.99-189.83,189.83-189.83h113.14a184.273,184.273,0,0,1,159.71,92.22c.46.8.92,1.6,1.37,2.41a183.669,183.669,0,0,1,23.26,89.71Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M960.505,195.97V727.59c0,33.45-25.77,60.57-57.56,60.57H593.725a8.022,8.022,0,0,1-6.14-6.66V707.92a8.017,8.017,0,0,1,6.51-6.28h267.74c9.08,0,16.45-7.75,16.45-17.31V239.23c0-9.55-7.37-17.3-16.45-17.3H357.165c-9.08,0-16.44,7.75-16.44,17.3v48.4c0,9.56-7.37,17.31-16.45,17.31h-49.33c-9.09,0-16.45-7.75-16.45-17.31V195.97c0-33.45,25.77-60.56,57.56-60.56h586.89C934.735,135.41,960.505,162.52,960.505,195.97Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalProductionKanban);
export default __webpack_public_path__ + "static/media/icon-digitalProductionKanban.25a0d866398a3ff5bf9e41c570f85c8f.svg";
export { ForwardRef as ReactComponent };